import { render, staticRenderFns } from "./CampaignsHistoric.vue?vue&type=template&id=0722fcba"
import script from "./CampaignsHistoric.vue?vue&type=script&lang=js"
export * from "./CampaignsHistoric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports